import { React} from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Card, CardBody } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import { PolicyDetailsView } from './PolicyDetailsView';


const PolicyDetails = ({formik,setSelectedService,selectedData ,UserDetailAlt,policy_number,req_count}) => {
      
  return (
    <>

    <motion.div
        style={{ width: "100%" }}
        initial={{

            opacity: 0
        }}
        animate={{

            opacity: 1,
            transition: { duration: 0.3 }
        }}
    >
        <Row style={{margin:0}}>

            <Col xs={1} className='my-3'>
                <motion.div
                    whileTap={{
                        scale: 0.9
                    }}
                    onClick={() => { setSelectedService(0) }}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                </motion.div>
            </Col>

        </Row>
        <Row style={{ width: "100%",margin:0 }} className='d-flex justify-content-center align-items-center'>
            <Col xs={12}>
                <Row>
                    
                  <PolicyDetailsView req_count={req_count} formik={formik} selectedData={selectedData} policy_number={policy_number} UserDetailAlt={UserDetailAlt}/>
                </Row>

            </Col>

        </Row>
    </motion.div>
</>
  )
}

export default PolicyDetails
